import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styles from './styles/Banners.module.scss';

import Box from '../../Common/Box';

const OomiBanner: React.FunctionComponent = () => {
  const { t } = useTranslation();

  const [showBanner, setShowBanner] = React.useState<boolean>(localStorage.getItem('OomiLandingPageBannerDisplayed') !== 'true');

  return (
    <>
      {showBanner && (
        <Box className={styles.oomiBanner}>
          <button
            className={styles.dismiss}
            onClick={() => {
              setShowBanner(false);
              window.localStorage.setItem('OomiLandingPageBannerDisplayed', 'true');
            }}
          >
            <span>{t(`common:general.close`)}</span>
          </button>
          <h4>{t(`landingPage:oomiBanner.title`)}</h4>

          <p>
            <Trans
              i18nKey="landingPage:oomiBanner.description"
            />
          </p>
        </Box>
      )}
    </>
  );
};

export default OomiBanner;
